import { createSelector } from 'reselect';
import { hasFix } from '../../../shared/vulns/remediation';
import type { ReduxStore } from '../store';
import type { VulnsStore } from './types';

export const getVulnsStore = (state: ReduxStore) => state.vulns;
const createVulnsSelector = <R>(selectorFn: (state: VulnsStore) => R) =>
  createSelector(getVulnsStore, selectorFn);

export const getRemediationGuidance = createVulnsSelector((state: VulnsStore) => state.remediationGuidance);
export const getHasFixes = createSelector([getRemediationGuidance], ({ partialFix, completeFix }) => ({
  hasPartialFix: hasFix(partialFix),
  hasCompleteFix: hasFix(completeFix),
  hasMatchingFixes: partialFix === completeFix,
}));
export const getNextSafeVersion = createVulnsSelector((state: VulnsStore) => state.nextSafeVersion);
export const getNextSafeVersionList = createVulnsSelector((state: VulnsStore) => state.nextSafeVersionList);

export const getAsyncStatus = createVulnsSelector((state: VulnsStore) => state.asyncStatus);
export const getRemediationGuidanceStatus = createVulnsSelector(
  (state: VulnsStore) => state.asyncStatus.remediationGuidance);
export const getNextSafeVersionStatus = createVulnsSelector(
  (state: VulnsStore) => state.asyncStatus.nextSafeVersion);
export const getNextSafeVersionListStatus = createVulnsSelector(
  (state: VulnsStore) => state.asyncStatus.nextSafeVersionList);

// This returns the loading status rather than the entire async status for backwards computability
export const getCreatingSecurityExportLoading = createVulnsSelector(
  (state: VulnsStore) => state.asyncStatus.createOrgSecurityReport.loading);
